import React, { useState } from "react";
import "./Welcome.css";
import logoWhite from "../branding/feedgram_logo_white.svg";
import logoRed from "../branding/feedgram_logo.svg";
// import { Link, useRouter } from "found";
import { useNavigate } from "react-router-dom";
import LoginForm from "../LoginForm";
// import Home from "../Home";

function Welcome(props) {
	const [isLogin, setIsLogin] = useState(false);
	const [isSignup, setIsSignup] = useState(false);
	const navigate = useNavigate();

	function onLoginClick(e) {
		e.preventDefault();
		navigate("/login");
		// setIsLogin(true);
		// setIsSignup(false);
	}

	function onSignupClick(e) {
		e.preventDefault();
		navigate("/signup");
		// setIsSignup(true);
		// setIsLogin(false);
	}

	return (
		<div className="welcome-wrapper">
			<div className="welcome-container">
				<div className="auth-container-wrapper">
					<div className="auth-container landing-auth-container">
						<img className="brand-logo" src={logoRed} alt="" />
						<div className="auth-btn-container">
							<div>
								<button
									onClick={onSignupClick}
									className="btn-welcome"
								>
									Get Started
								</button>
								<span className="existing-member">
									Already a member?
									<button
										className="link-button"
										onClick={onLoginClick}
									>
										Login
									</button>
								</span>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	);
}

export default Welcome;
